import { useState } from 'react';

function useModal(isOpenDefault = false) {
  const [isOpen, setIsOpen] = useState(isOpenDefault);

  return {
    onOpen: () => {
      setIsOpen(true);
    },
    onClose: () => {
      setIsOpen(false);
    },
    isOpen
  };
}

export default useModal;
